import { call, put } from 'redux-saga/effects';
import { setUserDetails } from '../account/accountSlice';
import {
  requestFetchPincodeInfo,
  requestSaveNomineeDetails,
  requestSkipNomineeDetails,
} from './nomineeDetailsFormRequests';
import {
  setNomineeDetailsFormError,
  setNomineeDetailsFormStatus,
  setPincodeInfo,
  setSavedNomineeDetails,
  setSkipNomineeDetails,
} from './nomineeDetailsFormSlice';

export function* handleSaveNomineeDetails(action:any): Generator<any, any, any> {
  yield put(setNomineeDetailsFormStatus('loading'));

  try {
    const response = yield call(
      requestSaveNomineeDetails,
      action.payload
    );
    const { data } = response;
    // console.log('nominee', data);
    if (data) {
      yield put(setSavedNomineeDetails(action.payload));
      yield put(setUserDetails(data.user));
    }
  } catch (error: any) {
    // eslint-disable-next-line no-console
    console.log(error);
    yield put(setNomineeDetailsFormError({
      isError: true,
      type: 'save_nominee',
      message: error?.response?.data?.message,
    }));
  }
}

export function* handleSkipNomineeDetails(action:any): Generator<any, any, any> {
  yield put(setNomineeDetailsFormStatus('loading'));

  try {
    const response = yield call(
      requestSkipNomineeDetails,
      action.payload
    );
    const { data } = response;
    // console.log('skip nominee', data);
    if (data) {
      yield put(setSkipNomineeDetails(true));
      yield put(setUserDetails(data.user));
    }
  } catch (error: any) {
    // eslint-disable-next-line no-console
    console.log(error);
    yield put(setNomineeDetailsFormError({
      isError: true,
      type: 'skip_nominee',
      message: error?.response?.data?.message,
    }));
  }
}

export function* handleFetchPincodeInfo(action:any): Generator<any, any, any> {
  yield put(setNomineeDetailsFormStatus('loading'));

  try {
    const response = yield call(
      requestFetchPincodeInfo,
      action.payload
    );
    const { data } = response;
    if (data) {
      yield put(setPincodeInfo({ error: false, pincodeDetails: data, pincode: action.payload.pincode }));
    }
  } catch (error: any) {
    // eslint-disable-next-line no-console
    console.log(error);
    yield put(setPincodeInfo({ error: true, pincode: action.payload.pincode }));
  }
}
